// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "pre[class*=language-][data-v-07f37009]{background-color:#2d2d2d!important;color:#fff!important}code[class*=language-][data-v-07f37009]{color:#fff!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
